import { Component, OnInit } from '@angular/core';
import { MessageService, Message, ConfirmationService } from 'primeng/api';
import { ScheduleService } from 'src/app/services/schedule.service';
import { CaseService } from 'src/app/services/case.service';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { IHearingDate } from '../../shared/classes/hearing-date';
import { ApplicationMinutesDto  } from '../../application/case/dto/application-minutes.dto';
import { DatePipe } from '@angular/common';
import { Observable } from 'rxjs';

@Component({
  selector: 'update-minute',
  templateUrl: './update-minute.component.html',
})

export class UpdateMinuteComponent implements OnInit {

    hearingDateList: any[]; // IHearingDate[];
    myHearing: IHearingDate;
    myHearingId: number = 0;
    myCase: any;
    myMinutes: ApplicationMinutesDto;
    myDate: Date;
    schedCaseList: any[];

    displayState: any = {
        workingDiv: false,
        gridDiv: false,
        caseListDiv: false,
        editMinutesDiv: false,
        saveDisabled: false,
        deleteDisabled: false,
        headerFooterTextDiv: false,
    };

    isNewEntry: boolean = false;

    filterOptions: any = {
        filterText: '',
    };

    hasRequiredData: boolean = true;

    constructor(private messageService: MessageService, private schedService: ScheduleService, private caseService: CaseService,
             private confirmationService: ConfirmationService, private datePipe: DatePipe, private utilService: UtilitiesService) { }

    ngOnInit() {
        this.displayState.gridDiv = false;
        this.displayState.caseListDiv = false;
        this.displayState.newMinutesDiv = false;
        this.displayState.editMinutesDiv = false;
        this.getHearingDates();
    }

    // get list of defined Hearing Dates (for NON-FUTURE dates ONLY!)
    getHearingDates() {
        //console.log('getting hearing dates...');
        this.displayState.workingDiv = true;
        this.displayState.gridDiv = false;
        var tdy = new Date();
        this.schedService.getHearingDates().subscribe(data => {
            if (data) {
                this.hearingDateList = data.filter(t=> {
                    var tHearDt = new Date(t.hearingDate)
                    return tHearDt > tdy? null: t
                });
              let mapped = this.hearingDateList.map(item => ({
                ...item,
                hearingDateDesc: `${item.hearingDate.split('T')[0]} ${item.hearingTime}`
              }));
              this.hearingDateList = mapped;
            }
            this.displayState.workingDiv = false;
            this.displayState.gridDiv = true;
            this.displayState.caseListDiv = false;
            this.displayState.editMinutesDiv = false;
        })
    }

    // triggered when user selects a Hearing Date, for display of cases scheduled on that date...
    onSelectHearing(hearing: IHearingDate) {
        // get the hearing date's data; from grid or from API call??
        //
        // now, display the case list form
        this.utilService.doAudit(hearing,'select hearing:');
        console.log(hearing);
        this.myHearing = hearing;
        this.myHearingId = hearing.id;
        // get list of cases scheduled for this hearing date
        this.getScheduledCases(hearing.id.toString());
        // now set the header/footer text for selected hearing...
        this.displayState.headerFooterTextDiv = false;
        this.getPrePostMinutesText();
        return;
    }

    onSelectCase(caseObj: any) {
        let appId = caseObj.applicationId;
        this.myCase = caseObj;
        //console.log(appId + '; ' + this.myHearingId.toString());
        this.myMinutes = new ApplicationMinutesDto();
        this.getApplicationMinutes(appId, this.myHearingId.toString());
    }

    getApplicationMinutes(applicationId: string, hearingId: string) {
        this.displayState.editMinutesDiv = false;
        this.caseService.getHearingMinutes(applicationId, hearingId).subscribe(data => {
            if (data) {
                //console.log(data);
                this.myMinutes = data
            }
            else {
                //console.log('nothing returned...');
                this.myMinutes = {
                    applicationId: +applicationId,
                    hearingId: +hearingId,
                    hearingDate: new Date(this.myHearing.hearingDate),
                    minutesNote: '',
                    id: 0,
                    applicationIds: [],
                }
            }
            this.displayState.saveDisabled = false;
            this.displayState.deleteDisabled = false;
            this.displayState.editMinutesDiv = true;
        })
    }

    getScheduledCases(hearingId: string) {
        //console.log('hearing Id: ' + hearingId)
        this.displayState.caseListDiv = false;
        this.displayState.editMinutesDiv = false;
        this.schedService.getScheduledCasesAll(hearingId).subscribe(data => {
            if (data) {
                //console.log(data);
                // this.utilService.doAudit(data,'cases');
                //this.schedCaseList = data;
                // identify unique cases, via applicationId
                this.schedCaseList = [];
                let uniqData = [];
                const dLen = data.length;
                for (let i = 0, len = dLen; i < len; i++) {
                    uniqData[data[i].applicationId] = data[i];
                }
                // this.utilService.doAudit(uniqData,'unique cases');
                for (const key in uniqData) {
                    this.schedCaseList.push(uniqData[key]);
                }
                // this.utilService.doAudit(this.schedCaseList,'list');

            }
            this.displayState.caseListDiv = true;
        });
    }

    // save Minutes text
    saveMinutes() {
        if (this.validateMinutesData() === false) {
            this.showToast({ severity: 'error', detail: 'Required data is missing', summary: '' });
            return;
        }
        this.displayState.saveDisabled = true;
        this.displayState.deleteDisabled = true;
        //console.log(this.myHearing.boardMembers);
        this.caseService.saveHearingMinutes(this.myMinutes).subscribe(data => {
            //console.log('save returned: ' + data);
            if (data == "-1") {
                this.showToast({severity: 'error', detail: 'Problem saving Minutes', summary: ''})
                this.displayState.workingDiv = false;
            } else {
                this.showToast({ severity: 'success', detail: 'Minutes saved!.', summary: '' });
                this.displayState.editMinutesDiv = false;
                this.myMinutes = null;
            }
            this.displayState.saveDisabled = false;
            this.displayState.deleteDisabled = false;
        })
    }

    // verify Minutes Notes are present
    validateMinutesData() {
        if (this.myMinutes.minutesNote === '') {
          return false;
        }
        return true;
    }

    cancelEntry() {
        this.displayState.editMinutesDiv = false;
        return true;
    }

    // DELETE Minutes for specifed Application/Hearing Date
    deleteMinutes() {
        const applicationId = this.myMinutes.applicationId;
        const hearingId = this.myMinutes.hearingId;
        this.utilService.doAudit(this.myMinutes, 'Delete myMinutes:')
        this.confirmationService.confirm({
            message: 'Do you want to DELETE these Minutes?',
            header: 'Deleting Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.displayState.workingDiv = true;
                this.displayState.saveDisabled = true;
                this.displayState.deleteDisabled = true;
                this.caseService.deleteHearingMinutes(applicationId.toString(), hearingId.toString()).subscribe(data => {
                    this.displayState.workingDiv = false;
                    this.displayState.saveDisabled = false;
                    this.displayState.deleteDisabled = false;
                    this.showToast({ severity: 'success', detail: 'Minutes DELETED!.', summary: '' });
                    this.getScheduledCases(this.myHearingId.toString());
                });
            },
            reject: () => {
                this.showToast({severity: 'info', detail: 'No action performed.', summary: ''});
            }
        });
    }

    getPrePostMinutesText() {
        let xHearingId=this.myHearingId;
        if (this.myHearingId === this.myHearing.id) {
            this.schedService.getHearingDate(xHearingId.toString()).subscribe(data => {
                this.utilService.doAudit(data,'hearing (id=' + xHearingId + '):');
            });
        };
    }

    savePrePostMinutesText() {
        this.utilService.doAudit(this.myHearing,'saving myHearing:');
        //return true;

        if (this.myHearingId === this.myHearing.id) {
            this.schedService.saveHearingDate(this.myHearing).subscribe(data => {
                this.utilService.doAudit(data,'ret value from saveHeardingDate');
                if (data == true) {
                    this.displayState.headerFooterTextDiv = false;
                    this.showToast({severity: 'info', detail: 'Header/Footer data saved.', summary: ''});
                    return;
                } else {
                    this.showToast({severity: 'error', detail: 'ERROR saving Header/Footer data!', summary: ''});
                    return;
                }
            });
        };
    }

    headerFooterText() {
        this.displayState.headerFooterTextDiv = true;
    }
    headerFooterTextCancel() {
        this.displayState.headerFooterTextDiv = false;
    };

    showToast(msg: Message) {
        this.messageService.add(msg);
    }

    showConfirm() {
        this.messageService.clear();
        this.messageService.add({key: 'c', sticky: true, severity: 'warn', summary: 'Are you sure?', detail: 'Confirm to proceed'});
    }


      onConfirm() {
          this.messageService.clear('c');
      }

      onReject() {
          this.messageService.clear('c');
      }

      clear() {
        this.messageService.clear();
      }

}
